import React from "react";
import { useNavigate } from "react-router";
import { IdCard } from "lucide-react";
import { useTranslation } from "react-i18next";
import { maxPlatform } from "../services/maxPlatform";

/** Top-of-events-list entry: claim exhibitor access without picking a show first. */
export function ClaimExhibitorEntryCard() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => {
        maxPlatform.hapticFeedback("light");
        navigate("/claim-badge");
      }}
      className="w-full rounded-2xl border border-indigo-100 bg-indigo-50/80 px-4 py-3 text-left flex items-start gap-3"
    >
      <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600">
        <IdCard size={18} />
      </span>
      <span className="min-w-0">
        <span className="block text-[14px] font-semibold text-indigo-900">
          {t("events.claim_badge_cta")}
        </span>
        <span className="block text-[12px] text-indigo-700/80 mt-0.5 leading-snug">
          {t("events.claim_badge_cta_hint")}
        </span>
      </span>
    </button>
  );
}
